export default "__VITE_ASSET__YnZtWJqi__"